import {imagesHotDishes} from "./imageHotDishes";

export const hotDishes = [
    {
        id: 51,
        img: imagesHotDishes.kungPao,
        title: 'КУНГ-ПАО ЧИККЕН',
        structure: 'ФИЛЕ КУРИНОЕ,ЦУКИНИ,СЕЛЬДЕРЕЙ,МОРКОВЬ,ПАПРИКА,АРАХИС,СОУС СЛАДКИЙ ФИРМЕННЫЙ.\n',
        price: '350',
        weight: '240',
    },
    {
        id: 52,
        img: imagesHotDishes.EbiTempura,
        title: 'ЭБИ ТЕМПУРА',
        structure: 'КРЕВЕТКА ТИГРОВАЯ,ЛИСТ САЛАТА,СОУС СЛАДКИЙ ФИРМЕННЫЙ.',
        price: '395',
        weight: '150',
    },
    {
        id: 53,
        img: imagesHotDishes.Midii,
        title: 'МИДИИ',
        structure: 'МИДИИ КИВИ,СОУС ФИРМЕННЫЙ,КУНЖУТ.',
        price: '395',
        count: '',
    },
    {
        id: 54,
        img: imagesHotDishes.ikaFurai,
        title: 'ИКА ФФУРАЙ',
        structure: 'КОЛЬЦА КАЛЬМАРА,ЛИСТ САЛАТА,СОУС СЛАДКИЙ ФИРМЕННЫЙ.',
        price: '275',
        weight: '150',
    },
]